import { Link } from "@tanstack/react-router";
import type { ProviderType } from "@wags/catalog/pure.ts";
import { VerifiedProviderBadge } from "@/components/shared/VerifiedProviderBadge";

export function ListingProviderName({
    name,
    id,
    isVerified,
    providerType,
}: {
    name: string;
    id?: string;
    isVerified?: boolean;
    providerType: ProviderType;
}) {
    const label = id ? (
        <Link
            to="/provider/$providerId"
            params={{ providerId: id }}
            className="rounded text-body-small text-doberman-black/65 underline-offset-2 transition-colors [@media(hover:hover)]:hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-labrador-yellow"
        >
            {name}
        </Link>
    ) : (
        <span className="text-body-small text-doberman-black/65">{name}</span>
    );
    return (
        <span className="text-body-small">
            {label}
            <VerifiedProviderBadge
                isVerified={isVerified}
                providerType={providerType}
            />
        </span>
    );
}
